import React, { useState, useEffect } from "react";
import { Auth, API } from "aws-amplify";
import "../config";
import "./Setup.css";

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

import DokumentList from '../components/DokumentList';
import DokumentView from '../components/DokumentView';
import AutoRefresh from '../components/AutoRefresh';
import LoadingWrapper from '../components/LoadingWrapper';
import { useSnackbar } from 'notistack';
import { useContainerStyles } from '../styles/commonStyles';

export default function Setup(props) {
  const classes = useContainerStyles();
  const [isLoading, setIsLoading] = useState(false);
  const [documents, setDocuments] = useState([]);
  const [document, setDocument] = useState({});
  const [documentID, setDocumentID] = useState('');


  // Snackbar
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  useEffect(() => {
    async function fetchData() {
      setIsLoading(true)
      if (props.vendorID === '') {
        // master reset
        setDocuments([])
        setDocumentID('')
        setDocument({})
      } else {
        await loadDocuments()
      }
      setIsLoading(false)
    }
    fetchData()
  }, [props.vendorID])

  useEffect(() => {
    setIsLoading(true)

    if (documentID === '') {
      //console.log('create new!')
      setDocument({})
    } else {
      documents.forEach(dc => {
        if (dc.doc_id === documentID) {
          //console.log(dc)
          setDocument(dc)
        }
      })
    }
    setIsLoading(false)
  }, [documentID])

// Documents
function manageDocuments(documentsArray) {
  let managed = []
  documentsArray.forEach(ft => {
    if (!ft["geom"]){
      ft["geom"] = ''
    }
    managed.push(ft)

  });
  //console.log(managed)
  return managed
}

function base64ToBufferAsync(base64) {
  var dataUrl = "data:application/octet-binary;base64," + base64;

  fetch(dataUrl)
    .then(res => res.arrayBuffer())
    .then(buffer => {
      console.log("base64 to buffer: " + new Uint8Array(buffer));
    })
}

async function loadDocuments() {
  await getDocuments(props.vendorID)
  .then(response => {
    const managedDocuments = manageDocuments(response.data);
    setDocuments(managedDocuments);
    if (managedDocuments.length === 0) {
      enqueueSnackbar('Der er ingen dokumenter endnu', {variant: 'info'});
    }
  })
  .catch(response => {
    enqueueSnackbar('Kunne ikke hente dokumenter: '+ response.messsage,{variant: 'error',})
    setDocuments([])
  })
};
async function getDocuments(vendor_id) {
  let init = {
    headers: { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` }
  }
  return await API.post("API", "/Documents/"+vendor_id, init);
}
async function getDocumentHandler(id) {
  let response = await getDocument(id)
  console.log(response)

  const contentType = 'application/pdf'
  const url = "data:" + contentType + ";base64,"+response.data.base64

  const res = await fetch(url);
  const blob = await res.blob();
  const link = URL.createObjectURL(blob);
  
  return link
}
async function getDocument(id) {
  let init = {
    headers: { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` }
  }
  return await API.post("API", "/DocumentFile/"+id, init);
}
async function createDocumentHandler(values) {
  //console.log(values)
  await createDocument(values)
  .then(response => enqueueSnackbar('Dokument oprettet',{variant: 'success',}))
  .then(loadDocuments)
  .catch(response => {
    //console.log(response)
    enqueueSnackbar('Kunne ikke tilføje dokument: '+ response.messsage,{variant: 'error',})
  })
}
async function createDocument(values) {
  values["body"]["vendor_id"] = props.vendorID
  values["headers"] = { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` }
  
  //console.log(values)
  return await API.post("API", "/Document", values);
}
async function deleteDocumentHandler(id) {
  await deleteDocument(id)
  .then(response => enqueueSnackbar('Dokument fjernet',{variant: 'success',}))
  .then(loadDocuments)
  .catch(response => enqueueSnackbar('Kunne ikke fjerne dokument: '+ response.messsage,{variant: 'error',}))
}
async function deleteDocument(id) {
  let init = {
    headers: { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` }
  }
  return await API.del("API", "/Document/"+id, init);
}
async function editDocumentHandler(values) {
  await editDocument(values)
  .then(response => enqueueSnackbar('Dokument opdateret',{variant: 'success',}))
  .then(loadDocuments)
  .catch(response => enqueueSnackbar('Kunne ikke opdatere dokument: '+ response.messsage,{variant: 'error',}))
}
async function editDocument(values) {
  values["headers"] = { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` }
  return await API.put("API", "/Document/"+values.body.doc_id, values);
}

async function refresh() {
  if (props.vendorID !== '') {
    // clear selection
    setDocumentID('')
    setDocument({})
    
    await loadDocuments();
  }
}

  //console.log(props)
  return (
    <div className={classes.root}>
      <AutoRefresh onRefresh={refresh} disableAuto={true} disabled={props.vendorID === ''} />
      <LoadingWrapper isLoading={isLoading}>
      <Grid
      container
      spacing={4}
      direction="row"
      alignItems="flex-start"
      justifyContent="flex-start"
      >
        <Grid item xs={12}>
          <DokumentList
          props={props}
          docs={documents}
          set={setDocumentID}
          create={createDocumentHandler}
          delete={deleteDocumentHandler}
          vendorMeta={props.vendorMeta}
          />
        </Grid>
        {documentID !== '' && (
          <Grid item xs={12}>
              <DokumentView
                props={props}
                vendorMeta={props.vendorMeta}
                doc={document}
                edit={editDocumentHandler}
                create={createDocumentHandler}
                get={getDocumentHandler}
                />
          </Grid>
        )}
      </Grid>
      </LoadingWrapper>
    </div>
  );
}
